import AppBar from "@mui/material/AppBar";
import GradientBackground from "../gradientBackground/GradientBackground";

const BigLogo = () => {
    return (
        <>
            <GradientBackground />
            <AppBar className="custom-app-bar" position="absolute" sx={{ boxShadow: "none", top: "15px", backgroundColor: "transparent" }}>
                <a aria-label="Go to Waverley website" href="https://www.waverley.gov.uk/" target="_blank" className={"logo big-logo"} rel="noreferrer">
                    {" "}
                </a>
            </AppBar>
        </>
    );
};

export default BigLogo;
